import "./saleshistory.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import Button from "../../../Common/Buttons/Button";
import { type SaleState } from "../../../Reducers/SellScreen/SellScreenSaleReducerTypes";
import { type AdditionalSaleData } from "../../../Utilities/Domain/ReceiptHelper";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import SaleReceiptPrint from "../../SellScreen/Receipt/SaleReceiptPrint";

const connector = connect();

interface Props extends ConnectedProps<typeof connector> {
    dispatch: ThunkDispatch<any, any, any>;
    sale: SaleState;
    additionalSaleData?: AdditionalSaleData;
}

class ReprintReceipt extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.handleDoneClick = this.handleDoneClick.bind(this);
    }

    protected handleDoneClick(): void {
        this.props.dispatch(hideDialog());
    }

    public render(): React.ReactNode {
        return (
            <div className="reprint-receipt">
                <Button
                    type="button"
                    classes={[ "receipt-close" ]}
                    onClick={this.handleDoneClick}
                >
                    <FontAwesomeLight icon="times-circle" />
                </Button>
                <SaleReceiptPrint
                    dialog
                    history
                    isReprint
                    sale={this.props.sale}
                    additionalSaleData={this.props.additionalSaleData}
                />
            </div>
        );
    }
}

export default connector(ReprintReceipt);
